import { render } from "./CustomerSearch.vue?vue&type=template&id=b81eb074&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"

import "./CustomerSearch.vue?vue&type=style&index=0&id=b81eb074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81eb074"]])

export default __exports__